import {
    RedTariff,
    SalesChannel,
    URL_PARAM_SUBGROUP_ID,
    YoungTariff,
} from '@vfde-sails/constants';
import { SailsTariffOverviewStorage } from 'Container/App/interface';
import { getSubscriptionIdFromSails } from '@vfde-sails/storage';
import {
    getQueryParam,
    isRedTariff,
    isYoungTariff,
} from '@vfde-sails/utils';

/**
 * Get selected subscription ID
 */
export const getSelectedSubscriptionId = (
    storage: SailsTariffOverviewStorage | null,
    salesChannel: SalesChannel,
    availableSubscriptionIds: (RedTariff | YoungTariff)[],
): RedTariff | YoungTariff | null => {
    const subscriptionId =
        getActiveSubscriptionIdFromUrl()
        ?? getActiveSubscriptionIdFromStorage(storage, salesChannel)
    ;

    // In case we have a valid Red or Young tariff, but it's not available as per configured option picker,
    // we have to find the next best equivalent later
    if (
        (!isRedTariff(subscriptionId) && !isYoungTariff(subscriptionId))
        || !validateSubscriptionIdAgainstAvailableIds(subscriptionId, availableSubscriptionIds)
    ) {
        return null;
    }

    return subscriptionId;
};

/**
 * Get active subscription ID from storage
 */
export const getActiveSubscriptionIdFromStorage = (
    storage: SailsTariffOverviewStorage | null,
    salesChannel: SalesChannel,
): RedTariff | YoungTariff | null => {
    const subscriptionId = getSubscriptionIdFromSails(storage || {} as SailsTariffOverviewStorage, salesChannel);

    return subscriptionId as RedTariff | YoungTariff || null;
};

/**
 * Get active subscription ID from URL
 */
export const getActiveSubscriptionIdFromUrl = (): RedTariff | YoungTariff | null => {
    const subscriptionId = getQueryParam(URL_PARAM_SUBGROUP_ID) as RedTariff | YoungTariff;

    return subscriptionId || null;
};

const validateSubscriptionIdAgainstAvailableIds = (
    subscriptionId: RedTariff | YoungTariff,
    availableSubscriptionIds: (RedTariff | YoungTariff)[],
): boolean =>
    availableSubscriptionIds.some(id => id === subscriptionId);
